// react components
import React from 'react'
import {
    useDispatch,
} from 'react-redux'

// data
import {
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    IconBlock825,
    RichTextInputV2825,
    TextAreaInputV2825,
    TextInputV2825,
} from 'pages'

// serializers
import {
    ContentTypeFormTypes,
} from 'serializers/site'

// props
type TextNormalAndRichInput825Props = {
    disabled: boolean
    field: string
    isTextArea?: boolean
    object: ContentTypeFormTypes['data']['fields']
    onChange: any
    onKeyPress: any
}

// main
export const TextNormalAndRichInput825: React.FC<TextNormalAndRichInput825Props> = React.memo(({
    disabled,
    field,
    isTextArea,
    object,
    onChange,
    onKeyPress,
}) => {

    const dispatch = useDispatch()

    const isRich = object[`${field}_is_rich`]

    function onIsRichChange(event: boolean) {
        try {
            onChange({
                name: `${field}_is_rich`,
                value: event,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextNormalAndRichInput825',
                'onIsRichChange',
            ))
        }
    }

    return (
        <div className='text-normal-and-rich-input-825'>
            <div className='tnari-input-wrap'>
                {isRich
                    ? (
                        <RichTextInputV2825
                            disabled={disabled}
                            fonts={object.portfolio_main?.fonts}
                            name={`${field}_rich`}
                            objectId={object.id}
                            onChange={onChange}
                            presetColors={object?.preset_colors}
                            tinymceStylesString='todo'
                            value={object[`${field}_rich`] || ''}
                        />
                    ) : (
                        isTextArea
                            ? (
                                <TextAreaInputV2825
                                    disabled={disabled}
                                    name={field}
                                    onChange={onChange}
                                    value={object[field] || ''}
                                />
                            ) : (
                                <TextInputV2825
                                    disabled={disabled}
                                    name={field}
                                    onChange={onChange}
                                    onKeyPress={onKeyPress}
                                    value={object[field] || ''}
                                />
                            )
                    )
                }
            </div>
            <div className='tnari-input-action'>
                <IconBlock825
                    className='tnari-icon'
                    edit={false}
                    iconClass='mo-new-icon-layout-779'
                    onClick={() => onIsRichChange(!isRich)}
                    tabIndex={-1}
                />
            </div>
        </div>
    )
})
